export default "__VITE_ASSET__CuGaX$de__"